<script lang="ts">
  import type { CompetitorServiceCompetitorProduct } from '@shared/types/competitor-service';

  interface Props {
    rows: CompetitorServiceCompetitorProduct[];
  }

  const { rows }: Props = $props();

  function fieldText(value: string | null | undefined): string {
    const trimmed = value?.trim();
    return trimmed && trimmed.length > 0 ? trimmed : '未設定';
  }
</script>

<section class="competitor-products-readonly">
  <h2>競合ソリューション</h2>
  <p class="muted">
    自社ソリューション詳細の「競合ソリューション」タブで管理します。
  </p>

  {#if rows.length === 0}
    <p class="empty">この外部ソリューションを競合として設定している自社ソリューションはありません。</p>
  {:else}
    <div class="table-scroll">
      <table>
        <thead>
          <tr>
            <th>自社ソリューション名</th>
            <th>メモ</th>
            <th>競合利用</th>
          </tr>
        </thead>
        <tbody>
          {#each rows as row (row.product_competitor_service_id)}
            <tr>
              <td>{row.product_name}</td>
              <td class="memo-cell">{fieldText(row.memo)}</td>
              <td>{row.usage_target_count}</td>
            </tr>
          {/each}
        </tbody>
      </table>
    </div>
  {/if}
</section>

<style>
  .competitor-products-readonly {
    display: grid;
    gap: 12px;
  }
  h2 {
    margin: 0;
    font-size: 1rem;
  }
  .muted,
  .empty {
    margin: 0;
    color: #64748b;
    font-size: 0.875rem;
  }
  .table-scroll {
    overflow-x: auto;
  }
  table {
    width: 100%;
    border-collapse: collapse;
    font-size: 0.875rem;
  }
  th,
  td {
    padding: 10px 12px;
    border-bottom: 1px solid #e5e7eb;
    text-align: left;
    vertical-align: top;
  }
  th {
    color: #475569;
    font-weight: 700;
    background: #f8fafc;
  }
  .memo-cell {
    white-space: pre-wrap;
  }
</style>
